import React from "react";
import DistributorForm from "./DistributorForm";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";

const CreateDistributor = () => (
  <DashboardLayout>
    <DashboardNavbar />
    <DistributorForm />
  </DashboardLayout>
);

export default CreateDistributor;
